import React from "react";
import { Link } from "react-router-dom";
import { BellRing, Bot, BriefcaseBusiness, Compass, ListChecks, Sparkles } from "lucide-react";
import { PublicPageShell } from "./PageShells";

const previews = [
  { icon: Compass, title: "Job discovery", text: "Support for finding relevant roles based on your profile and goals." },
  { icon: ListChecks, title: "Application organisation", text: "A clearer way to keep job-search activity and next steps organised." },
  { icon: BellRing, title: "Helpful reminders", text: "Timely prompts designed to help you stay on top of your job search." },
  { icon: BriefcaseBusiness, title: "Application tracking", text: "A single view for following the progress of your applications." },
];

const ZamAgent = () => (
  <PublicPageShell
    eyebrow="Coming soon"
    title="Meet your AI job agent."
    intro="Zam Agent is JobZam’s planned job-search assistant, designed to bring discovery, organisation, reminders and personalised support into one focused workflow."
  >
    <div className="grid gap-6 lg:grid-cols-[1fr_0.7fr]">
      <section className="grid gap-4 sm:grid-cols-2" aria-label="Planned Zam Agent capabilities">
        {previews.map(({ icon: Icon, title, text }) => (
          <article key={title} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_12px_40px_rgba(15,23,42,0.06)]">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-700">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </div>
            <h2 className="mt-5 text-lg font-bold text-slate-950">{title}</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">{text}</p>
          </article>
        ))}
      </section>

      <aside className="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-600 to-indigo-700 p-7 text-white shadow-xl shadow-blue-500/15 sm:p-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15">
          <Bot className="h-6 w-6" aria-hidden="true" />
        </div>
        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-blue-50">
          <Sparkles className="h-3.5 w-3.5" aria-hidden="true" /> In development
        </p>
        <h2 className="mt-4 text-2xl font-black text-white">A more organised job search</h2>
        <p className="mt-3 leading-7 text-blue-100">
          The feature is currently in development. In the meantime, JobZam’s live tools can help you optimise your resume, prepare applications and explore jobs.
        </p>
        <div className="mt-7 flex flex-col gap-3">
          <Link to="/upload" className="inline-flex min-h-11 items-center justify-center rounded-xl bg-white px-5 py-3 text-sm font-bold text-blue-700 transition hover:bg-blue-50 focus:outline-none focus:ring-4 focus:ring-white/30">
            Explore JobZam
          </Link>
          <Link to="/" className="inline-flex min-h-11 items-center justify-center rounded-xl border border-white/20 px-5 py-3 text-sm font-bold text-white transition hover:bg-white/10 focus:outline-none focus:ring-4 focus:ring-white/20">
            Return Home
          </Link>
        </div>
      </aside>
    </div>
  </PublicPageShell>
);

export default ZamAgent;
